import { render, staticRenderFns } from "./DaysGallery.vue?vue&type=template&id=680ceb6b&scoped=true&"
import script from "./DaysGallery.vue?vue&type=script&lang=js&"
export * from "./DaysGallery.vue?vue&type=script&lang=js&"
import style0 from "./DaysGallery.vue?vue&type=style&index=0&id=680ceb6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680ceb6b",
  null
  
)

export default component.exports